import { ServiceRequest } from "../../api/ServiceRequest";

export class EmpShiftRequest extends ServiceRequest {
  startDate?: string; // LocalDateTime → ISO string
  endDate?: string; // LocalDateTime → ISO string
  userId?: number;

  constructor(init?: Partial<EmpShiftRequest>) {
    super(init);
    Object.assign(this, init);
  }

  // Getters & Setters
  getStartDate(): string | undefined {
    return this.startDate;
  }
  setStartDate(value: string | undefined): void {
    this.startDate = value;
  }

  getEndDate(): string | undefined {
    return this.endDate;
  }
  setEndDate(value: string | undefined): void {
    this.endDate = value;
  }

  getUserId(): number | undefined {
    return this.userId;
  }
  setUserId(value: number | undefined): void {
    this.userId = value;
  }
}
